import MDBox from "../../../../../components/MDBox";
import MDTypography from "../../../../../components/MDTypography";
import Grid from "@mui/material/Grid";
import FormField from "../../../../pages/events/new-event/components/FormField";
import MuiPhoneNumber from "material-ui-phone-number";
import {ErrorMessage, Field} from "formik";
import {useEffect, useRef, useState} from "react";
import {useIsuniqueMutation} from "../../../../../store/api/validation";
import ReCAPTCHA from "react-google-recaptcha";

export const EmailMobile = ({formData, setNextValid}) => {
    const {formField, values, errors, touched, setFieldValue} = formData;
    const {email, mobile} = formField;
    const {
        email: emailV,
        mobile: mobileV,
    } = values;
    const [is_unique] = useIsuniqueMutation();
    const [checkEmailUnique, setCheckEmailUnique] = useState();
    const [checkMobileUnique, setCheckMobileUnique] = useState();
    const [recaptchaToken, setRecaptchaToken] = useState();
    const [checkedEmail, setCheckedEmail] = useState(false);
    const [checkedMobile, setCheckedMobile] = useState(false);

    const checkUniqueEmail = async (email) => {
        const payload = await is_unique({
            'prop': 'email',
            'value': email
        }).unwrap();
        setCheckEmailUnique(payload.data[0]?.unique)
        setCheckedEmail(true);
    };

    const checkUniqueMobile = async (mobile) => {
        const payload = await is_unique({
            'prop': 'phone',
            'value': mobile
        }).unwrap();
        setCheckMobileUnique(payload.data[0]?.unique)
        setCheckedMobile(true);
    };


    useEffect(() => {
        setNextValid(checkMobileUnique && checkEmailUnique && recaptchaToken)
    }, [
        checkMobileUnique, checkEmailUnique, recaptchaToken
    ]);

    useEffect(() => {
        setCheckedEmail(false);

        if (emailV !== "" && !(errors?.email)) {
            checkUniqueEmail(emailV);

        }
    }, [emailV]);

    useEffect(() => {
        setCheckedMobile(false);
        if (mobileV !== "" && !(errors?.mobile) && mobileV.length === 13) {
            checkUniqueMobile(mobileV)
        }
    }, [mobileV]);

    const recaptchaRef = useRef();

    return (
        <MDBox>
            <MDTypography variant="h5">Email & Mobile</MDTypography>
            <MDBox mt={3}>
                <Grid container spacing={3}>
                    <Grid item xs={12} sm={12}>
                        <FormField
                            type={email.type}
                            label={email.label}
                            name={email.name}
                            value={emailV}
                            placeholder={email.placeholder}
                            error={errors.email && touched.email}
                            success={emailV.length > 0 && !errors.email}
                        />
                        {
                            checkedEmail && (<MDBox mt={0.75}>
                                <MDTypography component="div" variant="caption"
                                              color={checkEmailUnique ? "success" : "error"} fontWeight="regular">
                                    {checkEmailUnique ? "You can use this e-mail" : "Cannot be used this e-mail"}
                                </MDTypography>
                            </MDBox>)
                        }
                    </Grid>
                    <Grid item xs={12} sm={12}>
                        <MDBox mb={1.5}>
                            <Field defaultCountry="tr"
                                   onlyCountries={['tr']}
                                   onChange={(newValue) => {
                                       setFieldValue("mobile", newValue.replace(/\s/g, ''));
                                   }}
                                   fullWidth
                                   name={mobile.name} as={MuiPhoneNumber} variant="standard" label={mobile.label}/>
                            <MDBox mt={0.75}>
                                <MDTypography component="div" variant="caption" color="error" fontWeight="regular">
                                    <ErrorMessage name={mobile.name}/>
                                </MDTypography>
                            </MDBox>
                            {
                                checkedMobile && (<MDBox mt={0.75}>
                                    <MDTypography component="div" variant="caption"
                                                  color={checkMobileUnique ? "success" : "error"} fontWeight="regular">
                                        {checkMobileUnique ? "You can use this mobile" : "Cannot be used this mobile"}
                                    </MDTypography>
                                </MDBox>)
                            }
                        </MDBox>

                    </Grid>
                    <Grid item xs={12} sm={12}>
                        <ReCAPTCHA
                            ref={recaptchaRef}
                            style={{ display: "inline-block" }}
                            sitekey="6LdZkOMiAAAAAF-8GfAqn60jZ5mwsGpv6c8vncob"
                            onChange={(value) => {
                                setFieldValue("recaptcha", value);
                                setRecaptchaToken(value);
                            }}
                            asyncScriptOnLoad={() => setFieldValue("recaptcha", "")}
                        />
                    </Grid>

                </Grid>
            </MDBox>
        </MDBox>
    )
}